import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { apiRequest } from "../../utils/api";
import { useNotification } from "../../context/notification";
import Autocomplete from "../Autocomplete";

import Select from "../Select";
import styles from "./index.module.scss";
import { TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  select: {
    color: "rgba(0, 0, 0, 0.87)",
  },
}));

function GetAllCountries({
  countryChange,
  api,
  showAllCountry = true,
  multi = false,
  ...props
}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { addNotification } = useNotification();
  const [isLoading, setIsLoading] = useState(true);
  const [allCountries, setAllCountries] = useState(
    showAllCountry
      ? [{ value: "all", label: t("sessionList.allCountries") }]
      : []
  );
  const [selectedCountry, setSelectedCountry] = useState("all");

  useEffect(() => {
    getAllCountries();
  }, []);

  useEffect(() => {
    countryChange(selectedCountry);
  }, [selectedCountry]);

  async function getAllCountries() {
    let url = api ? api : "/api/getSupportAdminAllCountries";
    setIsLoading(true);
    const response = await apiRequest.get(url);

    if (response.status === 200) {
      let data = response.data.data;
      if (data.length > 0) {
        data = data.map(item => {
          return {
            value: item.id
              ? item.id
              : item.region_id
                ? item.region_id
                : item.u_rid,
            region_id: item.id
              ? item.id
              : item.region_id
                ? item.region_id
                : item.u_rid,
            label: item.title,
            ...item,
          };
        });
        if (!multi) {
          data = [...allCountries, ...data];
        }
        setAllCountries(data);

        if (!showAllCountry) {
          setSelectedCountry(data[0].value);
        }
      }
    } else {
      addNotification(
        t("error.couldNotGetCountryList") +
          ` (Status code: ${response.status})`,
        "error"
      );
    }
    setIsLoading(false);
  }

  return (
    <>
      {!multi && (
        <Select
          list={allCountries}
          value={selectedCountry}
          className={`${classes.select} ${styles.toolBarDropDown}`}
          variant="standard"
          onChange={e => {
            setSelectedCountry(e.target.value);
          }}
        />
      )}
      {multi && (
        <Autocomplete
          value={selectedCountry}
          defaultValue={selectedCountry}
          onChange={(event, newValue) => {
            setSelectedCountry(newValue);
          }}
          options={allCountries}
          getOptionLabel={option => option.label}
          style={{ width: 360 }}
          renderInput={params => (
            <TextField
              {...params}
              placeholder="Select Country"
              variant="outlined"
            />
          )}
        />
      )}
    </>
  );
}

export default GetAllCountries;
